import {Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {ConfService} from '../conf.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar} from '@angular/material';
import {InjectLogsDirective} from '../deploymentplan/deploymentplan.component';
import {ProgressLogsComponent} from '../progress-logs/progress-logs.component';
import {WebsocketService} from '../websocket.service';

@Component({
    selector: 'app-deploy-api',
    templateUrl: './deploy-api.component.html',
    styleUrls: ['./deploy-api.component.scss']
})
export class DeployApiComponent implements OnInit {

    @Input() partner: string;
    @Input() account: string;
    @Input() entity: string;
    @Input() version: string;
    @Input() type: any;
    @Input() dataTypeFilter: any;
    @Input() databases: any;
    @Input() targetPartner: any;
    @Input() targetAccount: any;
    @Input() targetPkey: any;
    @Input() renderType: any;
    @Input() apiDeploymentStatus: any;
    targetDatabases: any;
    partnerDatabases: any;
    datatypes: any;
    selectedDatatypeFilter: any;
    @Output() apiPromoted: EventEmitter<any> = new EventEmitter<any>();
    APIName: any;
    APIVersion: any;
    APIType: any;
    timeStamp: any;
    isAPIAlreadyExists: boolean;
    existingAPI: any;
    manageProgressId: any;
    componentLoading = true;
    apiDependenciesList = [];
    origDependenciesList = [];
    tabData = [];
    renderedAPIs = [];
    renderedExecutors = [];
    activeTabIndex = 0;

    logVisible = false;
    destroy: any;
    guard = 0;
    isWebSocketConnectionEstablished = false;
    componentRef;
    action: any;
    @ViewChild(InjectLogsDirective, {static: false}) injectComp: InjectLogsDirective;

    constructor(public platform: LeftpanelComponent, public confPost: ConfService,
                private websocketService: WebsocketService,
                private _componentFactoryResolver: ComponentFactoryResolver,
                public dialog: MatDialog) {
    }

    async ngOnInit() {
        if (this.platform.datatypes !== null && this.platform.datatypes !== undefined) {
            this.datatypes = this.platform.datatypes;
        } else {
            await this.confPost.getDataTypes().toPromise().then(data => {
                    this.datatypes = data;
                    this.platform.datatypes = data;
                },
                error => {
                    this.platform.handleErrorGracefully(error, 'Error while getting list of data types. Please try again after sometime.');
                });
        }

        if (this.platform.databases !== null && this.platform.databases !== undefined) {
            this.databases = this.platform.databases;
        } else {
            await this.confPost.getDatabases(localStorage.getItem('partner')).toPromise().then(async databases => {
                    await this.platform.updateIsNoSQLForMongo(databases);
                    this.databases = this.platform.databases;
                },
                error => {
                    this.platform.handleErrorGracefully(error, 'Error while getting list of databases. Please try again after sometime.');
                });
        }
        //this.getDatabaseTypeForDatabaseName(this.entityToBePromoted['database']);
        this.dataTypeFilter = [];
        this.datatypes.filter(items => {
            if (items.database_type === this.selectedDatatypeFilter) {
                this.dataTypeFilter.push(items);
            }
        });
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        await this.getPartnerDatabases(loaderDialog);
    }

    getPartnerDatabases(loaderDialog: MatDialogRef<LoaderWithProgressComponent>) {
        this.targetDatabases = [];
        return new Promise((resolve, reject) => {
            this.confPost.getDatabasesForPartner(this.targetPartner, this.targetPkey).subscribe(response1 => {
                if (response1 && response1 !== null && response1 !== undefined && response1.status && response1.status === 200) {
                    if (response1.body && response1.body !== null && response1.body !== undefined) {
                        if (response1.body && response1.body !== null && response1.body !== undefined) {
                            let databases: any;
                            this.partnerDatabases = response1.body;
                            this.partnerDatabases.forEach(db => {
                                if (db && db !== null && db !== undefined) {
                                    if (db['database_type'] === this.selectedDatatypeFilter) {
                                        this.targetDatabases.push(db);
                                    }
                                }
                            });
                            loaderDialog.close();
                            resolve('success');
                        } else {
                            resolve('failed');
                        }
                    } else {
                        resolve('failed');
                    }
                } else {
                    resolve('failed');
                }
            }, error => {
                resolve('failed');
                loaderDialog.close();
                this.platform.handleErrorGracefully(error, 'Error while retrieving target partner\'s databases.');
            });
        });
    }

    dependentAPIs(apis) {
        let tabData = {};
        this.apiDependenciesList = apis;
        this.origDependenciesList = JSON.parse(JSON.stringify(apis));
        if (this.apiDependenciesList && this.apiDependenciesList.length) {
            if (this.apiDependenciesList[0]['executor_name']) {
                if (this.apiDependenciesList[0]['executor_type'] === 'BUSINESSLOGIC') {
                    tabData['type'] = 'businessLogicAPIs';
                }
                if (this.apiDependenciesList[0]['executor_type'] === 'SQLQUERY') {
                    tabData['type'] = 'sqlQueryAPIs';
                }
                if (this.apiDependenciesList[0]['executor_type'] === 'TESTSUITE') {
                    tabData['type'] = 'testSuiteAPIs';
                }
                if (this.apiDependenciesList[0]['executor_type'] === 'THIRDPARTY') {
                    tabData['type'] = 'thirdpartyAPIs';
                }
                tabData['selectedAPIExecutorPlan'] = this.apiDependenciesList[0];
                tabData['blocklyRendered'] = false;
                tabData['index'] = 0;
                this.renderedAPIs.push(0);
                this.tabData.push(tabData);
            } else {
                tabData['type'] = 'dataAccessAPIs';
                tabData['selectedEntityPlan'] = this.apiDependenciesList[0];
                tabData['blocklyRendered'] = false;
                tabData['index'] = 0;
                this.renderedAPIs.push(0);
                this.tabData.push(tabData);
            }

        }

    }

    onItemSelected(index) {
        let tabData = {};
        if (this.apiDependenciesList && this.apiDependenciesList.length) {
            if (this.apiDependenciesList[index]['executor_name'] && !this.renderedAPIs.includes(index)) {
                if (this.apiDependenciesList[index]['executor_type'] === 'BUSINESSLOGIC') {
                    tabData['type'] = 'businessLogicAPIs';
                }
                if (this.apiDependenciesList[index]['executor_type'] === 'SQLQUERY') {
                    tabData['type'] = 'sqlQueryAPIs';
                }
                if (this.apiDependenciesList[index]['executor_type'] === 'TESTSUITE') {
                    tabData['type'] = 'testSuiteAPIs';
                }
                if (this.apiDependenciesList[0]['executor_type'] === 'THIRDPARTY') {
                    tabData['type'] = 'thirdpartyAPIs';
                }
                tabData['selectedAPIExecutorPlan'] = this.apiDependenciesList[index];
                tabData['blocklyRendered'] = false;
                tabData['index'] = index;
                this.renderedAPIs.push(index);
                this.tabData.push(tabData);
                this.activeTabIndex = this.tabData.length - 1;
            } else {
                if (!this.renderedAPIs.includes(index)) {
                    tabData['type'] = 'dataAccessAPIs';
                    tabData['selectedEntityPlan'] = this.apiDependenciesList[index];
                    tabData['blocklyRendered'] = false;
                    tabData['index'] = index;
                    this.renderedAPIs.push(index);
                    this.tabData.push(tabData);
                    this.activeTabIndex = this.tabData.length - 1;
                }
            }
        }
    }

    getPartnerDatabaseConnections(index) {
        if (this.origDependenciesList[index].database) {
            const dataTypeFilter = this.getDatabaseTypeForDatabaseName(this.origDependenciesList[index].database);
            let targetDatabases = [];
            if (this.partnerDatabases && this.partnerDatabases.length) {
                this.partnerDatabases.forEach(db => {
                    if (db && db !== null && db !== undefined) {
                        if (db['database_type'] === dataTypeFilter) {
                            targetDatabases.push(db);
                        }
                    }
                });
            }
            return targetDatabases;
        }

    }

    getDatabaseTypeForDatabaseName(val) {
        let selectedDatatypeFilter: any;
        if (this.databases) {
            this.databases.filter(items => {
                if (items.database_name === val) {
                    selectedDatatypeFilter = items.database_type;
                }
            });
        }
        return selectedDatatypeFilter;
    }

    getPartnerDatabaseConnectionsForSQL(index) {
        if (this.origDependenciesList[index].executors[0].database) {
            const dataTypeFilter = this.getDatabaseTypeForDatabaseName(this.origDependenciesList[index].executors[0].database.database_name);
            let targetDatabases = [];
            if (this.partnerDatabases && this.partnerDatabases.length) {
                this.partnerDatabases.forEach(db => {
                    if (db && db !== null && db !== undefined) {
                        if (db['database_type'] === dataTypeFilter) {
                            targetDatabases.push(db);
                        }
                    }
                });
            }
            return targetDatabases;
        }

    }

    closeTab(index) {
        const apiIndex = this.renderedAPIs.indexOf(this.tabData[index].index);
        this.renderedAPIs.splice(apiIndex, 1);
        this.tabData.splice(index, 1);
        this.activeTabIndex = this.tabData.length - 1;
    }

    promoteAPI(apiDependencies) {
        this.logVisible = false;
        this.apiPromoted.emit(apiDependencies);
    }

    saveEntity(entity, index) {
        this.apiDependenciesList[index].database = entity.database;
        // this.tabData[index].selectedEntityPlan = this.apiDependenciesList[index];
        this.platform.openSnackBar('Saved Successfully.', 'Success', {
            duration: 2000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

    saveSqlQueryAPI(executorModel, index) {
        this.apiDependenciesList[index].executors = [executorModel];
        // this.tabData[index].selectedEntityPlan = this.apiDependenciesList[index];
        this.platform.openSnackBar('Saved Successfully.', 'Success', {
            duration: 2000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

    closeLogPanel() {
        this.logVisible = false;
        this.componentRef.destroy();
        this.guard = 0;
    }

    showLog(selectedItem) {
        if (!this.logVisible) {
            this.logVisible = true;
        }

        this.APIName = selectedItem.apiName;
        this.APIVersion = selectedItem.apiVersion;
        this.APIType = selectedItem.apiType;
        this.timeStamp = selectedItem.timeStamp;
        this.action = selectedItem.action;

        if (this.guard === 0) {
            this.create();
        } else {
            this.componentRef.destroy();
            this.create();
        }
    }

    create() {
        if (this.websocketService.isOpen()) {
            this.isWebSocketConnectionEstablished = true;
        } else {
            this.isWebSocketConnectionEstablished = false;
        }
        this.guard = 1;
        

        const componentFactory = this._componentFactoryResolver.resolveComponentFactory(ProgressLogsComponent);
        this.componentRef = this.injectComp.viewContainerRef.createComponent(componentFactory);
        this.componentRef.instance.apiType = this.APIType;
        this.componentRef.instance.entityName = this.APIName;
        this.componentRef.instance.version = this.APIVersion;
        // this.componentRef.instance.currentMessage = this.currentMessage;
        this.componentRef.instance.connection = this.isWebSocketConnectionEstablished;
        this.componentRef.instance.action = this.action;
        // this.componentRef.instance.partner = this.partner;
        // this.componentRef.instance.account = this.account;
        // this.componentRef.instance.session = this.session;
        this.componentRef.instance.timeStamp = this.timeStamp;
        this.componentRef.instance.refreshCount = 1;
        //this.componentRef.instance.lightbox_open();
        // this.componentRef.instance.CloseClicked.subscribe(res => {
        //     if (res) {
        //         this.componentRef.destroy();
        //         this.guard = 0;
        //     }
        // });
    }
}
